import {
  Button,
  Modal,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  Box,
  Typography
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { LoaderScreen } from "../../../components/LoaderScreen";

export const ModalGuardarDatosContacto = ({
  open,
  handleCloseModal,
  idcliente,
}) => {
  const [datosContacto, setDatosContacto] = useState({
    idcliente: "",
    medio_contacto: "",
    valor: "",
    comentarios: "",
    utilizado: 0, 
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setDatosContacto((prevState) => ({ ...prevState, idcliente }));
  }, [idcliente]);

  const handleChange = (event) => {
    setDatosContacto({
      ...datosContacto,
      medio_contacto: event.target.value.trim(),
    });
  };

  const handleTextChange = (event) => {
    setDatosContacto({
      ...datosContacto,
      [event.target.id]: event.target.value,
    });
  };

  const handleCheckboxChange = (event) => {
    setDatosContacto({
      ...datosContacto,
      utilizado: event.target.checked ? 1 : 0, 
    });
  };
  // console.log(datosContacto)
  const handleAdd = () => {
    // console.log(datosContacto);
    setLoader({ ...loader, mostrar: true });
    request
      .post("ClientesDatosContactoGuardar/Guardar", datosContacto)
      .then((response) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "Éxito",
          "Los datos de contacto se han guardado correctamente.",
          "success"
        );
        handleCloseModal();
      })
      .catch((error) => {
        console.error(error);
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "Error",
          "Ocurrió un error al guardar los datos de contacto.",
          "error"
        );
      });
  };

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <LoaderScreen loader={loader} />
        <div className="credito-agregar-modal-title">
          <div className="filtro-soy-el-titulo-header">
            <h3>GUARDAR DATOS DE CONTACTO</h3>
          </div>
        </div>
        <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
          <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
          <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
          <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
        </div>

        <div>
          <FormControl fullWidth>
            <InputLabel id="select-responsable-cobranza-label">
              Medio de Contacto
            </InputLabel>
            <Box display="flex" alignItems="center" >
              <Select
                labelId="select-responsable-cobranza-label"
                id="medio_contacto"
                className="select-responsable"
                value={datosContacto.medio_contacto}
                onChange={handleChange}
                label="Medio de Contacto"
                sx={{ flexGrow: 1 }} 
              >
                <MenuItem value={"C"}>Correo</MenuItem>
                <MenuItem value={"T"}>Teléfono</MenuItem>
                <MenuItem value={"W"}>WhatsApp</MenuItem>
                <MenuItem value={"P"}>Pagina web</MenuItem>
              </Select>
              <Checkbox
                checked={datosContacto.utilizado === 1} 
                onChange={handleCheckboxChange}
                sx={{ marginLeft: 0, marginBottom: 3 }} 
              />
              <Typography sx={{ marginBottom: 3 }}>Automatización</Typography> 
            </Box>
          </FormControl>

          <TextField
            id="valor"
            label="Contacto"
            sx={{ mb: 2, width: 540 }}
            value={datosContacto.valor}
            onChange={handleTextChange}
          />

          <TextField
            id="comentarios"
            label="Comentarios"
            multiline
            rows={3}
            sx={{ mb: 2, width: 540 }}
            value={datosContacto.comentarios}
            onChange={handleTextChange}
          />
        </div>

        <div className="credito-crear-tasa-interes-modal-button-container">
          <Button onClick={handleCloseModal} variant="contained" color="error">
            Cerrar
          </Button>
          <Button onClick={handleAdd} variant="contained">
            Guardar
          </Button>
        </div>
      </div>
    </Modal>
  );
};
